import React from 'react'

import SelectField from '~/components/Fields/SelectField'
import { LOCATION_TYPES } from '~/constants/locationTypes'

function LocationTypeField ({ ...props }) {
  return (
    <SelectField
      data-cy="locationType"
      name="locationType"
      label="Location type"
      options={LOCATION_TYPES}
      {...props}
    />
  )
}

export default LocationTypeField
